<template>
  <div style="margin:10px">
    <v-form direction="horizontal">
      <v-form-item label="参数名称" :label-col="labelCol" :wrapper-col="wrapperCol">
        <v-input v-model="options.p_bz" disabled="true" placeholder="参数名称"></v-input>
      </v-form-item>
      <v-form-item label="参数代码" :label-col="labelCol" :wrapper-col="wrapperCol">
        <v-input v-model="options.p_dm" disabled="true" placeholder="参数代码"></v-input>
      </v-form-item>
      <v-form-item label="参数值" :label-col="labelCol" :wrapper-col="wrapperCol">
        <v-input v-model="options.p_val" placeholder="参数值"></v-input>
      </v-form-item>
       <v-form-item
        label="启用"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-switch v-model="options.xy_bz"></v-switch>
      </v-form-item>
    </v-form>
    <div style="text-align:center">
      <v-button type="success" @click="save" icon="save">保存</v-button>
      <v-button type="error" @click="cancel" icon="close-circle-o">取消</v-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
var options = {
  p_bz: "",
  p_dm: "",
  p_val: "",
  xy_bz:true
};
export default {
  data: () => ({
    options,
    labelCol: {
      span: 6
    },
    wrapperCol: {
      span: 14
    },
  }),
  created() {
    if(this.$route.query.id){
      this.options.id = this.$route.query.id;
      this.inIt();
    }
  },
  methods: {
    inIt: function() {
      axios.get(
        "api/system/qxgl/get-cs-first?id=" +
          this.$route.query.id
      )
      .then(res => {
          debugger
          if(res.data.xy_bz == "1"){
          res.data.xy_bz = true
        }
          this.options = res.data;
        });
    },
    cancel: function() {
      xadmin.close();
    },
    save: function() {
      axios
        .post(
          "api/system/qxgl/set-cs-first",this.options
        )
        .then(res => {
           if (res.data.code == 200) {
              this.$message["success"](res.data.message);
              xadmin.close();
            } else {
              this.$message["error"](res.data.message);
            }
        })
        .catch(function(error) {
          // 请求失败处理
          console.log(error);
        });
    }
  }
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/xtcsadd.vue